const { string } = require("prop-types");
const { ROUTES } = require("../routing/routes");

const isOrderSummaryPage = pathname => {
  return pathname === ROUTES.OFFER_SUMMARY;
};

isOrderSummaryPage.propTypes = {
  pathname: string.isRequired,
};

module.exports = { isOrderSummaryPage };
